<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <transition name="slide-fade">
      <app-loader v-if="this.$store.state.loading"></app-loader>
    </transition>
    <div class="page">
      <div class="r fit">
        <app-header :auth="this.$store.state.auth"></app-header>
      </div>
      <div class="r content container">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <div class="r fit">
        <app-footer></app-footer>
      </div>
    </div>
  </v-app>
</template>

<script>
import AppFooter from "@/components/footer";
import AppHeader from "@/components/header";
import AppLoader from "@/components/loader";
export default {
  name: 'App',
  components: {AppFooter,AppHeader,AppLoader},
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
};
</script>

<style lang="scss">
  .v-application--is-ltr .v-messages{
    display: none !important;
  }
  .v-input--selection-controls{
    margin: 0 !important;
    padding: 0 !important;
  }
  @mixin shadow{
    box-shadow: 0 1px 3px 0 rgba(21,27,38,.15);
  }
  a{
      text-decoration: none;
  }
  html, body, button, #app{
    font-family: 'Montserrat', sans-serif !important;
  }
  h5{
    font-size: 0.9rem;
    font-weight: 500;
  }
  h1{
    font-size: 2.5rem;
    font-weight: 600;
    line-height: 1.0;
  }
  h2{
    font-size: 1.3rem;
    font-weight: 600;
  }
  h3{
    font-size: 1.25rem;
    font-weight: 500;
  }
  .spinner{
    background: var(--v-primary-base) !important;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th{
    font-weight: 500;
    font-size: 1rem;
    &:first-child {
      min-width: 164px;
    }
    &:nth-child(2) {
      min-width: 164px;
    }
    &:nth-child(3) {
      min-width: 120px;
    }
    &:nth-child(4) {
      min-width: 120px;
    }
    &:nth-child(5) {
      min-width: 120px;
    }
    &:nth-child(6) {
      min-width: 120px;
    }
  }
  .page {
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    .bra{
      border-radius: 16px;
    }
    .elm {
      text-align: center;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .fill {
      flex: 1;
    }
    .breadcrumb {
      text-align: left;
      color: var(--v-secondary-base);
    }
    .v-data-table{
      border-radius: 16px;
      width: 100%;
    }
  }
  @mixin border {
    width: 100% !important;
    padding: 8px !important;
    border: 2px solid rgba(64,93,110,0.25) !important;
    font-size: 1rem;
    border-radius: 8px !important;
    line-height: 1rem;
    outline: none;
  }
  input, select {
    height: 40px;
  }
  textarea{
    resize: none !important;
    display: inherit;
  }
  .input{
    @include border;
  }
  .inputErr{
    @include border;
    border: 2px solid rgba(189,81,81,0.75) !important;
  }
  .inputWarn{
    @include border;
    border: 2px solid rgba(189,81,81,0.75) !important;
  }
  .page{
    height: 100%;
    display: flex;
    flex-flow: column;
    .r.content{
      position:relative;
      display: flex;
      flex: 1 1 auto;
    }
    .r.fit{
      flex: 0 1 auto;
    }
  }
  .v-input--selection-controls .v-input__slot > .v-label{
    line-height: 0.1rem !important;
  }
  .theme--dark.v-btn.v-btn--disabled .v-icon, .theme--dark.v-btn.v-btn--disabled .v-btn__loading{
    color: grey !important;
  }
  .v-input--selection-controls .v-input__slot, .v-input--selection-controls .v-radio{
    margin-bottom: 0;
  }
</style>
